import { BaseTestQuestionDto } from "@packages/api/madlenAPI.schemas";
import { useTranslation } from "react-i18next";
import { StudentAssignmentDetailTeacherPerspectiveResponseDtoQuestionsWithStudentAnswersItem } from "@packages/api/madlenAPI.schemas";
import Markdown from "react-markdown";

interface TestOptionsProps {
  question:
    | BaseTestQuestionDto
    | StudentAssignmentDetailTeacherPerspectiveResponseDtoQuestionsWithStudentAnswersItem;
}

export const TestOptions = ({ question }: TestOptionsProps) => {
  const isTeacherView = "studentAnswer" in question;

  const options = isTeacherView
    ? (question.question as BaseTestQuestionDto).options
    : (question as BaseTestQuestionDto).options;

  const correctAnswer = isTeacherView
    ? (question.question as BaseTestQuestionDto).answer
    : (question as BaseTestQuestionDto).answer;

  const studentAnswer = isTeacherView ? question.studentAnswer : null;

  return (
    <div className="mt-4">
      <div className="grid grid-cols-1 gap-3">
        {Object.entries(options).map(([key, option], index) => (
          <div
            key={index}
            className={`flex items-center gap-3 p-3 border rounded-lg hover:border-blue-500 dark:hover:border-blue-400 transition-colors ${
              key === correctAnswer
                ? "bg-green-50 dark:bg-green-900/30 !border-green-200 !dark:border-green-800"
                : studentAnswer === key && key !== correctAnswer
                  ? "bg-red-50 dark:bg-red-900/30 !border-red-200 !dark:border-red-800"
                  : "bg-white dark:bg-gray-700 border-gray-200 dark:border-gray-600"
            }`}
          >
            <span
              className={`flex-shrink-0 w-8 h-8 flex items-center justify-center ${
                key === correctAnswer
                  ? "bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-100"
                  : studentAnswer === key && key !== correctAnswer
                    ? "bg-red-100 dark:bg-red-900 text-red-800 dark:text-red-100"
                    : "bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-100"
              } font-semibold rounded-full`}
            >
              {String.fromCharCode(65 + index)}
            </span>
            <span
              className={`${
                key === correctAnswer
                  ? "text-green-700 dark:text-green-300"
                  : studentAnswer === key && key !== correctAnswer
                    ? "text-red-700 dark:text-red-300"
                    : "text-gray-700 dark:text-gray-300"
              }`}
            >
              <Markdown>{option}</Markdown>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
